import type { ThemeAppearance } from '@atlaskit/lozenge';
import {
	StatusCategoryTypes,
	type StatusCategoryKeys,
} from '@atlassian/jira-common-constants/src/status-categories';
import { LOZENGE_APPEARANCE } from '@atlassian/jira-platform-board-kit';

export const getStatusAppearance = (statusCategory: StatusCategoryKeys): ThemeAppearance => {
	const { default: defaultAppearance, inprogress, success } = LOZENGE_APPEARANCE;
	const StatusCategoryAppearances = Object.freeze({
		[StatusCategoryTypes.UNDEFINED]: defaultAppearance,
		[StatusCategoryTypes.NEW]: defaultAppearance,
		[StatusCategoryTypes.DONE]: success,
		[StatusCategoryTypes.INDETERMINATE]: inprogress,
	});

	return StatusCategoryAppearances[statusCategory] || defaultAppearance;
};
